import { AppHeader } from '@core/components'
import type { AppHeaderProps } from '@core/core/types'
import type { FC } from 'react'
import { Outlet } from 'react-router-dom'

export const Layout: FC<AppHeaderProps> = ({ logout, getToken }) => {
  return (
    <>
      <AppHeader getToken={getToken} logout={logout} />
      <Outlet />
    </>
  )
}
